import React, { Suspense, useEffect, useState } from "react";
import { useImage } from "react-image";
import globalComp from "../../../../../global/components";

interface ImageCellProps {
  imageUrl: string;
  onClick?: any;
  isCoverImage?: boolean;
  hoverElement?: JSX.Element;
  isChecked?: boolean;
  removeIsCheckedTimeout?: number;
}

function ImageCell({
  imageUrl,
  isCoverImage,
  hoverElement,
  isChecked,
  removeIsCheckedTimeout,
  ...props
}: ImageCellProps): JSX.Element {
  const [checked, setChecked] = useState<boolean>(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  useEffect(() => {
    if (removeIsCheckedTimeout && isChecked) {
      setTimeout(() => {
        setChecked(false);
      }, removeIsCheckedTimeout);
    }
  }, [checked, removeIsCheckedTimeout]);

  return (
    <div className={"social-upload__col"}>
      <div className={`social-upload__image-wrap ${checked && "active"}`}>
        <Suspense fallback={<Spinner />}>
          <Img
            loader={<Spinner />}
            unloader={<Unloaded />}
            url={imageUrl}
            {...props}
          />
          {hoverElement && hoverElement}
        </Suspense>
      </div>
    </div>
  );
}

export default ImageCell;

function Img({ url, ...props }: any) {
  const { src } = useImage({
    srcList: [url],
  });
  return <img src={src} {...props} />;
}

function Spinner() {
  return (
    <div
      className={"position-absolute"}
      style={{
        top: "50%",
        left: "50%",
        marginTop: -15,
        marginLeft: -15,
      }}>
      <globalComp.Spinner size={30} color={"white"} />
    </div>
  );
}

function Unloaded() {
  return (
    <div
      className={
        "position-absolute w-100 h-100 d-fle justify-content-center align-items-center"
      }
      style={{
        top: 0,
        left: 0,
      }}>
      <p>Error</p>
    </div>
  );
}
